export default "__VITE_ASSET__cdc323f4__"